import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { LayoutProvider, LayoutSplashScreen } from 'metronic/layout/core';
import { AuthProvider, ShellProvider } from 'app/providers';
import { PollingNotifications } from 'app/hocs/notifications/PollingNotifications';
import { I18nProvider } from 'metronic/i18n/i18nProvider';
import { MasterInit } from 'metronic/layout/MasterInit';
import CustomToastContainer from 'metronic/layout/CustomToastContainer';

export const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <I18nProvider>
        <LayoutProvider>
          <AuthProvider>
            <ShellProvider>
              <PollingNotifications>
                <Outlet/>
                <MasterInit/>
                <CustomToastContainer/>
              </PollingNotifications>
            </ShellProvider>
          </AuthProvider>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  );
};